export const SIDEBAR_EXPANDED_STORAGE_KEY = 'genufit.sidebar.expanded'
export const SIDEBAR_EXPAND_ON_HOVER_STORAGE_KEY = 'genufit.sidebar.expandOnHover'

export const SIDEBAR_PREFS_CHANGED_EVENT = 'genufit:sidebar-prefs-changed'

function notifySidebarPrefsChanged(key: string): void {
  if (typeof window === 'undefined') return
  window.dispatchEvent(
    new CustomEvent(SIDEBAR_PREFS_CHANGED_EVENT, { detail: { key } })
  )
}

export function readSidebarExpanded(): boolean {
  if (typeof window === 'undefined') return false
  try {
    return window.localStorage.getItem(SIDEBAR_EXPANDED_STORAGE_KEY) === 'true'
  } catch {
    return false
  }
}

export function readSidebarExpandOnHover(): boolean {
  if (typeof window === 'undefined') return false
  try {
    return window.localStorage.getItem(SIDEBAR_EXPAND_ON_HOVER_STORAGE_KEY) === 'true'
  } catch {
    return false
  }
}

export function writeSidebarExpanded(expanded: boolean): void {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.setItem(SIDEBAR_EXPANDED_STORAGE_KEY, expanded ? 'true' : 'false')
    notifySidebarPrefsChanged(SIDEBAR_EXPANDED_STORAGE_KEY)
  } catch {
    // ignore quota / private mode
  }
}

export function writeSidebarExpandOnHover(enabled: boolean): void {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.setItem(
      SIDEBAR_EXPAND_ON_HOVER_STORAGE_KEY,
      enabled ? 'true' : 'false'
    )
    notifySidebarPrefsChanged(SIDEBAR_EXPAND_ON_HOVER_STORAGE_KEY)
  } catch {
    // ignore quota / private mode
  }
}
